<input
  type="file"
  class="file-input"
  (change)="onFileSelected($event)"
  [accept]="requiredFileType"
  #fileUpload
  [multiple]="multiple"
/>

<div class="file-upload d-flex align-items-center mb-3">
  <button
    mat-mini-fab
    color="primary"
    class="upload-btn"
    (click)="fileUpload.click()"
    type="button"
  >
    <mat-icon>attach_file</mat-icon>
  </button>

  <div class="ml-4 w-100">
    <span>{{ uploaderTitle || 'No file uploaded yet.' }}</span>
    <div class="d-flex align-items-center">
      <div class="progress progress-container mr-2" *ngIf="uploadProgress">
        <div
          class="progress-bar bg-success"
          role="progressbar"
          [style.width.%]="uploadProgress"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
      <mat-icon (click)="cancelUpload()" *ngIf="uploadProgress">close</mat-icon>
    </div>
  </div>
</div>
